import React, { Component, PropTypes } from 'react';

export default class SimpleOverview extends Component {
  static propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  getHeaderStyle() {
    return {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: 24,
      fontWeight: '500',
      lineHeight: '48px',
      paddingLeft: 16,
      borderStyle: 'none none solid none',
      borderWidth: 1,
      borderColor: 'rgba(0, 0, 0, 0.12)'
    };
  }

  render() {
    let { header, children, ...other } = this.props;
    return (
      <div {...other}>
        <div style={this.getHeaderStyle()}>{header}</div>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/Overview.js